import { azureDataExplorerTableMetadata } from 'app/registries/dataset/azure-data-explorer-table-metadata';
import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

/**
 * For `Trident🔱` Kusto workspace
 */
export const kustoDatabaseTableMetadata: IDatasetTypeMetadata = {
    ...azureDataExplorerTableMetadata,
    icon: {
        className: 'svg-i-20x20-KQL_database'
    },
    type: adfModelTypeMap.kustoDatabase.datasetType,
    displayName: stringResources.KustoDatabase_DisplayText,
    disabled: !__IS_FABRIC_DPE__,
    supportLinkedServiceTypes: [adfModelTypeMap.kustoDatabase.linkedServiceType],
    supportDataFlowSink: false,
    supportDataFlowSource: false
};
